const CHANGE_SUMMARY_FILTER = 'CHANGE_SUMMARY_FILTER';
const UNDEF = 'undefined';

const getNewData = (data) => {
    let filterData = null;
    for (const [key, value] of Object.entries(data)) {
        const isValidData = typeof value !== UNDEF || (Array.isArray(value) && value?.length > 0);
        
        if (isValidData) {
            if (!filterData) {
                filterData = {};
            }
            filterData[key] = value; 
        }
    }

    return filterData;
};

const updateSummary = (state = {}, action) => {
    const { type = null, datasource } = action;
    if (type === 'dataEngine_update_response') {
        if (datasource === 'gumbo') {
            const {
                gamePk,
                liveData: {
                    plays: {
                        playsByInning = [],
                        allPlays = []
                    } = {}
                } = {}
            } = action?.data || {};

            const previousGamePk = state?.gamePk;
            const incomingGamePk = gamePk;
            const isOutOfSync = (previousGamePk !== incomingGamePk);
            if (isOutOfSync) {
                // We're switching games, so clear out the old data.
                return {
                    playsByInning,
                    allPlays,
                    gamePk
                };
            }

            return {
                ...state,
                playsByInning,
                allPlays

            };
        } else if (datasource === 'contentGraph' || datasource === 'content') {
            const { playVideoMap } = action?.data || {};
            return {
                ...state,
                highlights: playVideoMap
            };
        } else if (datasource === 'playMetrics') {
            const { data = {} } = action;

            const {
                scoringPlays,
                homeRuns,
                hardHits,
                strikeouts,
                leadChange,
                winProb,
                keyMoments
            } = data;
            
            const newData = getNewData({
                scoringPlays,
                homeRuns,
                hardHits,
                strikeouts,
                leadChange,
                winProb,
                keyMoments
            });
           
            if (newData) {
                return {
                    ...state,
                    ...newData
                };
            };

            return state;
        }
    }

    if (type === CHANGE_SUMMARY_FILTER) {
        const { selected } = action;
        return {
            ...state,
            summaryFilterIndex: selected[0]
        };
    }

    return state;
};

export default updateSummary;
